import { FC, ReactNode } from 'react';

import ProgressBar from 'components/FreeTrialFTUX/ui/ProgressBar';

interface StepShellProps {
  heading: string;
  description?: string;
  stepNumber: number;
  onSkip: () => void;
  skipLabel: string;
  isTransitioning: boolean;
  rightPanel: ReactNode;
  bottomAction: ReactNode;
  skipInBottomRow?: boolean;
}

const SkipButton: FC<{ onClick: () => void; label: string; className?: string }> = ({ onClick, label, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={`font-roboto text-md font-medium text-gray-1000 hover:text-gray-900 ${className || 'self-start'}`}
  >
    {label}
  </button>
);

const StepShell: FC<StepShellProps> = ({
  heading,
  description,
  stepNumber,
  onSkip,
  skipLabel,
  isTransitioning,
  rightPanel,
  bottomAction,
  skipInBottomRow = false,
}) => (
  <div
    className={`flex flex-col gap-5 p-6 transition-all duration-300 ease-out md:min-h-[28rem] md:flex-row md:gap-0 md:p-0 ${
      isTransitioning ? 'translate-y-1 opacity-0' : 'translate-y-0 opacity-100'
    }`}
  >
    <div className="flex flex-col gap-3 md:w-64 md:shrink-0 md:gap-5 md:py-12 md:pl-9 md:pr-6">
      <h2 className="font-roboto text-3xl font-medium leading-9 text-gray-900 md:text-4xl md:leading-10">{heading}</h2>
      {description && (
        <p className="font-roboto text-md font-medium leading-6 text-gray-1000 md:text-xl md:leading-8">
          {description}
        </p>
      )}
      <div className="mt-auto hidden flex-col gap-3 md:flex">
        <ProgressBar currentStepNumber={stepNumber} />
        {!skipInBottomRow && <SkipButton onClick={onSkip} label={skipLabel} />}
      </div>
    </div>

    <div className="hidden w-px self-stretch bg-gray-300 md:block" />

    <div className="flex min-w-0 flex-1 flex-col gap-5 md:px-9 md:py-12">
      <div className="flex-1">{rightPanel}</div>
      {skipInBottomRow ? (
        <div className="flex items-center gap-4">
          <SkipButton onClick={onSkip} label={skipLabel} className="hidden md:inline-flex" />
          <div className="flex-1">{bottomAction}</div>
        </div>
      ) : (
        bottomAction
      )}
    </div>

    <div className="flex flex-col gap-3 md:hidden">
      <SkipButton onClick={onSkip} label={skipLabel} />
      <ProgressBar currentStepNumber={stepNumber} />
    </div>
  </div>
);

export default StepShell;
